
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/111-120/blockType117';
import { faThumbtack } from '@delfi.lt/fa-kit/icons/modules/classic/solid';
import Service from '@root/common/base/Service';

const defaultSettings = {
  config: [
    {
      tickarooId: '',
      articleId: '',
      title: '',
    },
  ],
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  data() {
    return {
      activeTabIndex: 0,
      messages: {} as Record<string, any[]>,
      faThumbtack,
    };
  },

  mounted() {
    this.fetchMessages();
  },

  methods: {
    setActiveTab(index: number): void {
      this.activeTabIndex = index;
    },

    async fetchMessages(): Promise<void> {
      if (!this.data?.config?.length) {
        return;
      }

      const ids = this.data?.config.map((item: any) => item.tickarooId);
      const service = new Service();
      const apiProvider = service.createProvider('HTTP');
      let apiUrl = '/api/tickaroo-api';

      // Needed for developing, testing and admin preview
      const referer = window.location.href.toLowerCase();
      if (referer.includes('localhost')) {
        apiUrl = 'https://localhost:3000/api/tickaroo-api';
      } else if (referer.includes('admin.test.delfi.lt')) {
        apiUrl = 'https://www.test.delfi.lt/api/tickaroo-api';
      } else if (referer.includes('admin.delfi.lt')) {
        apiUrl = 'https://www.delfi.lt/api/tickaroo-api';
      }

      try {
        const response = await apiProvider.request<
          {
            dlb_id: string;
            messages: any[];
          }[]
        >({
          url: apiUrl,
          method: 'post',
          data: { ids },
        });

        const mapped: Record<string, any[]> = {};

        response.forEach((item) => {
          mapped[item.dlb_id] = item.messages || [];
        });

        this.messages = mapped;
      } catch (error) {
        console.error(`Internal tickaroo API error: ${error}`);
      }
    },
  },
});
